module.exports = "//static.hsappstatic.net/salesImages/static-1.403/sales-content/contacts-add-mobile.svg"